import { html } from 'lit';
import { actionLink } from '../components/actionLink.js';
import { sectionHeading } from '../components/sectionHeading.js';
import { type LandingContent, landingPageContentRepository } from '../../shared/content/landingContent.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const reasonsSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    class=${editorNodeClass(editor, 'section.reasons', 'vp-section vp-reasons-section')}
    style=${editorNodeStyle(editor, 'section.reasons')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.reasons', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.reasons', event)}
  >
    <div class="vp-shell vp-reasons-layout">
      <div>
        ${sectionHeading({
          eyebrow: content.reasons.eyebrow,
          title: content.reasons.title,
          highlight: content.reasons.titleHighlight,
          text: content.reasons.text,
          editor,
          elementPrefix: 'reasons',
        })}
        <div class="vp-section-actions">
          ${actionLink({
            action: content.hero.primaryAction,
            variant: 'secondary',
            editor,
            elementId: 'reasons.primaryAction.label',
          })}
        </div>
      </div>

      <div
        class=${editorNodeClass(editor, 'reasons.imageStack', 'vp-image-stack')}
        style=${editorNodeStyle(editor, 'reasons.imageStack')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'reasons.imageStack', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'reasons.imageStack', event)}
      >
        <img
          class=${editorNodeClass(editor, 'reasons.articleImage')}
          style=${editorNodeStyle(editor, 'reasons.articleImage')}
          src=${content.reasons.image || landingPageContentRepository.articleImage}
          alt=${content.locale === 'tr'
            ? 'Viva Porta ile Almanya’da bakım kariyeri'
            : content.locale === 'en'
              ? 'Care career in Germany with Viva Porta'
              : 'Viva Porta Pflegekarriere in Deutschland'}
          @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'reasons.articleImage', event)}
          @click=${(event: MouseEvent) => editorNodeClick(editor, 'reasons.articleImage', event)}
        />
        <div class="vp-image-stack-note">
          <span class="icon-[material-symbols--diversity-3]"></span>
          <p
            class=${editorNodeClass(editor, 'reasons.card.0.title')}
            style=${editorNodeStyle(editor, 'reasons.card.0.title')}
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'reasons.card.0.title', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'reasons.card.0.title', event)}
          >
            ${content.reasons.cards[0]?.title}
          </p>
        </div>
      </div>
    </div>

    <div
      class=${editorNodeClass(editor, 'reasons.cards.container', 'vp-shell vp-card-grid vp-card-grid-three')}
      style=${editorNodeStyle(editor, 'reasons.cards.container')}
      @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'reasons.cards.container', event)}
      @click=${(event: MouseEvent) => editorNodeClick(editor, 'reasons.cards.container', event)}
    >
      ${content.reasons.cards.map(
        (card, index) => html`
          <article
            class=${editorNodeClass(editor, `reasons.card.${index}`, 'vp-info-card reveal-card')}
            style=${editorNodeStyle(editor, `reasons.card.${index}`)}
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `reasons.card.${index}`, event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, `reasons.card.${index}`, event)}
          >
            <span
              class=${editorNodeClass(editor, `reasons.card.${index}.icon`, card.iconClass)}
              style=${editorNodeStyle(editor, `reasons.card.${index}.icon`)}
              @pointerdown=${(event: PointerEvent) =>
                editorNodePointerDown(editor, `reasons.card.${index}.icon`, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, `reasons.card.${index}.icon`, event)}
            ></span>
            <h3
              class=${editorNodeClass(editor, `reasons.card.${index}.title`)}
              style=${editorNodeStyle(editor, `reasons.card.${index}.title`)}
              @pointerdown=${(event: PointerEvent) =>
                editorNodePointerDown(editor, `reasons.card.${index}.title`, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, `reasons.card.${index}.title`, event)}
            >
              ${card.title}
            </h3>
            <p
              class=${editorNodeClass(editor, `reasons.card.${index}.text`)}
              style=${editorNodeStyle(editor, `reasons.card.${index}.text`)}
              @pointerdown=${(event: PointerEvent) =>
                editorNodePointerDown(editor, `reasons.card.${index}.text`, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, `reasons.card.${index}.text`, event)}
            >
              ${card.text}
            </p>
          </article>
        `,
      )}
    </div>
  </section>
`;
